import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useDispatch } from 'react-redux';
import UIIcon from 'UIComponents/icon/UIIcon';
import { useCanGoBack } from '../hooks/useCanGoBack';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { goPrevStep } from '../store/flow/action-creators';
import { useTracker } from '../tracking/useTracker';
import { StyledUILink } from './TextInput.styles';
export const BackLink = () => {
  const dispatch = useDispatch();
  const Tracker = useTracker();
  const {
    currentStep
  } = useCurrentStep();
  const {
    canGoBack,
    completedStep
  } = useCanGoBack();

  if (!canGoBack || !completedStep) {
    return null;
  }

  const onClick = event => {
    event.preventDefault();
    Tracker.backButton(currentStep, completedStep);
    dispatch(goPrevStep());
  };

  return /*#__PURE__*/_jsxs(StyledUILink, {
    className: "BackLink",
    href: "",
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "left"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'button.back'
    })]
  });
};